import { render } from "./add_custom_component.vue?vue&type=template&id=326e28e4&scoped=true"
import script from "./add_custom_component.vue?vue&type=script&lang=js"
export * from "./add_custom_component.vue?vue&type=script&lang=js"

import "./add_custom_component.vue?vue&type=style&index=0&id=326e28e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-326e28e4"]])

export default __exports__